import AuthManager from "Common/AuthManager"
import ServiceWrapper from "Services/ServiceWrapper"
import AppSettings from "Settings/AppSettings"

export const getCategoryById = (categoryid: string) => {
    return new Promise(async (resolve, reject) => {
        const res = await ServiceWrapper.doGet(
            AppSettings.GMS_BACKEND_API_URL + `category/details/${categoryid}`,
            null,
            null,
            AuthManager.getGmsToken()
        )

        // No row (unknown/deleted id) is a failure too: resolving `undefined` here used to land
        // in ProductsContext.selected_Category and crash the category dropdown on `.name`.
        const category = res.errorfound ? undefined : res.data?.data?.[0]
        if (!category) return reject("Could not fetch category")
        resolve(category)
    })
}